// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3C5hG","info":"PatientInfo_info__3b1R3"};